<template>
<div>
  <!-- 未ログイン -->
  <p v-if="!isLoggedIn" class="alert"
    data-color="danger">ログインしていません
  </p>
  <!-- ログイン済 -->
  <div v-if="user">
    <h1 class="p-mypage__heading">
      <strong class="u-tx-brand">{{ user.nickname || '未設定' }}</strong>
      さんのプロフィール
    </h1>
    <div class="u-mg-t-2 u-mg-b-2 u-tx-center">
      <a href="#">受信箱</a>
    </div>

    <div class="profileViewer">
      <profile-item
        label="おなまえ"
        type="text"
        label-desc="レターの中で使われる呼び方です。"
        name="nickname"
        :value="user.nickname"
        :editable="true"
        @update="updateProfile"
      ></profile-item>

      <profile-item
        label="生年月日"
        type="date"
        name="birthday"
        :value="user.birthday"
        :editable="true"
        @update="updateProfile"
      ></profile-item>
    </div>

    <pre>{{ user }}</pre>
  </div>

</div>
</template>

<script>
import { mapState } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import ProfileItem from './ProfileItem'

export default {
  name: 'profile-viewer',
  components: {
    ProfileItem
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      isLoggedIn: state => state.auth.isLoggedIn,
      accessToken: state => state.auth.accessToken
    })
  },
  methods: {
    updateProfile(param = {}) {
      const params = Object.assign(param, {
        access_token: this.accessToken
      })
      const newValueObj = Object.assign(this.user.profile, params)
      this.$store.dispatch(type.UPDATE_PROFILE_DATA, newValueObj)
    }
  },
  created() {
    // 未ログインの場合ログインページへ
    if (!this.isLoggedIn) {
      location.href = '/user/login'
    }
  }
}</script>

<style lang="scss" scoped>
.p-mypage {
  &__heading {
    font-weight: bold;
    font-size: 14px;
    text-align: center;
    > strong {
      color: #8cc63f;
      font-size: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ProfileViewer.vue